import myjobs from './myjobs';
import detail from './detail';
import jobFeedback from './jobFeedback';
import userJobFeedback from './userJobFeedback';
import oneJob from './oneJob';
import oneJobUpdate from './oneJobUpdate';
import cancel from './cancel';
import cancelGroupJob from './cancelGroupJob';
import oneJobOld from './oneJobOld';
import groupJobUpdate from './groupJobUpdate';

export default {
  myjobs,
  detail,
  jobFeedback,
  userJobFeedback,
  cancelGroupJob,
  oneJob,
  oneJobOld,
  oneJobUpdate,
  cancel,
  groupJobUpdate,
};
